import { toast } from '../../components/ui/Toast/useToast';
import { instance } from '../../config/intercepter';

export const getOffersFn = async () => {
  const response = await instance.get(`api/offerscheck`);
  return response.data;
};

export const offerApproveReject = async (url, payload = '') => {
  const response = await instance.post(`${url}`, payload);
  return response.data;
};

export const getOfferStatusFn = async (cncode) => {
  const response = await instance.get(`api/offerscheck/${cncode}`);
  return response.data;
};

export const getCustomerTypeFn = async () => {
  const response = await instance.get(`api/customertypes`);
  return response.data;
};

export const getDropdownOptions = async (url) => {
  const response = await instance.get(url);
  return response.data;
};

export const getRequiredDocuments = async (cncode) => {
  const response = await instance.get(`api/requireddocuments/${cncode}`)
  return response.data;
}

export const saveFileFn = async (payload) => {
  const response = await instance.post(`api/orders/${payload.cncode}/savefile`, payload.data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const postPreferenceFormFn = async (payload) => {
  const response = await instance.post(`api/orders/${payload.cncode}/preferencesform`, payload.data);
  return response.data;
};

export const saveValidationFileFn = async (payload) => {
  const response = await instance.post(
    `api/orders/${payload.cncode}/savevalidationfiles`, payload.data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getBankOptionsFn = async () => {
  const response = await instance.get('api/banks');
  return response.data
}

export const getStandingOrderLink = async () => {
  const response = await instance.get('api/standingorderlink');
  return response.data
}

export const acceptOffer = async (cncode) => {
  const response = await instance.post(`/api/orders/${cncode}/accept`,[])
  return response.data;
}

export const downloadOffer = async (link) => {
  instance.get(
    link,
    {
      headers: {
        "content-type": "application/json",
        Accept: "application/pdf",
      },
      responseType: 'arraybuffer',
    }
  ).then(response => {
    if (response.status === 200) {
      try {
        const file = new Blob([response.data], {
          type: "application/pdf;base64",
        });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } catch (e) {
        console.log(e);
      }
    } else {
      toast({
        variant: 'destructive',
        description: 'Κάτι πήγε στραβά',
      });
    }
  }).catch(()=>toast({
    variant: 'destructive',
    description: 'Κάτι πήγε στραβά',
  }));
}